import { render, staticRenderFns } from "./SecureOptionSectionView.vue?vue&type=template&id=1b9a6761&scoped=true&"
import script from "./SecureOptionSectionView.vue?vue&type=script&lang=js&"
export * from "./SecureOptionSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a6761",
  null
  
)

export default component.exports